<div class="generated-call-details">
  @if (isContentRefreshing) {
    <div class="generated-call-details-skeleton" [style.max-height]="contentMaxHeight || null">
      @for (label of skeletonSectionLabels; track label) {
        <p class="skeleton-heading">{{ label }}</p>
        <div class="skeleton-lines">
          @for (line of skeletonLines; track line) {
            <div class="skeleton-bar"></div>
          }
        </div>
      }
    </div>
  } @else {
    <div
      class="generated-call-details-content"
      [style.max-height]="contentMaxHeight || null"
      [innerHTML]="contentMarkdown | processMarkdown"
    ></div>
  }

  <div class="generated-call-details-divider"></div>

  @if (isRefinementBlocked && !overrideBannerDismissed()) {
    <div class="refinement-warning-banner">
      <p class="refinement-warning-banner-text">
        {{ 'simulationBuilder.REFINEMENT_OVERRIDDEN_PREFIX' | transloco }}
        <a class="refinement-warning-banner-link" [href]="'mailto:' + ('simulationBuilder.SUPPORT_EMAIL' | transloco)">{{ 'simulationBuilder.SUPPORT_EMAIL' | transloco }}</a>
        {{ 'simulationBuilder.REFINEMENT_OVERRIDDEN_SUFFIX' | transloco }}
      </p>
      <button type="button" class="refinement-warning-banner-close" (click)="dismissOverrideBanner()">
        <qai-icon kind="x-close" size="16px" />
      </button>
    </div>
  }

  @if (refinementStatus === CallRefinementStatus.Thinking) {
    <p class="refinement-status-text">{{ 'simulationBuilder.REFINEMENT_THINKING_MESSAGE' | transloco }}</p>
  } @else if (refinementStatus === CallRefinementStatus.Updated) {
    <p class="refinement-status-text">{{ 'simulationBuilder.REFINEMENT_UPDATED_MESSAGE' | transloco }}</p>
  } @else if (refinementStatus === CallRefinementStatus.Warning) {
    <div class="refinement-warning-banner">
      <p class="refinement-warning-banner-text">
        {{ 'simulationBuilder.REFINEMENT_WARNING_PREFIX' | transloco }}
        <a class="refinement-warning-banner-link" href="mailto:help@quantified.ai">help&#64;quantified.ai</a>
        {{ 'simulationBuilder.REFINEMENT_WARNING_SUFFIX' | transloco }}
      </p>
      <button type="button" class="refinement-warning-banner-close" (click)="handleDismissWarning()">
        <qai-icon kind="x-close" size="16px" />
      </button>
    </div>
  } @else if (refinementStatus === CallRefinementStatus.OutOfScope) {
    <p class="refinement-error-text">
      {{ 'simulationBuilder.REFINEMENT_ERROR_PREFIX' | transloco }}
      <a class="refinement-error-text-link" href="mailto:help@quantified.ai">help&#64;quantified.ai</a>
      {{ 'simulationBuilder.REFINEMENT_ERROR_SUFFIX' | transloco }}
    </p>
  } @else if (refinementStatus === CallRefinementStatus.Error) {
    <p class="refinement-processing-error-text">{{ 'simulationBuilder.REFINEMENT_ERROR_MESSAGE' | transloco }}</p>
  }

  <div
    class="request-changes-row"
    [class.request-changes-row--disabled]="isSubmitLocked"
    [class.request-changes-row--overlapping]="isRefinementBlocked && !overrideBannerDismissed()"
  >
    <input
      qai-input
      class="request-changes-input"
      [formControl]="requestChangesControl"
      [placeholder]="'simulationBuilder.REQUEST_CHANGES_PLACEHOLDER' | transloco"
      (keydown.enter)="handleRequestChangesKeydown($event)"
    />
    <button
      type="button"
      class="request-changes-submit"
      [disabled]="isSubmitLocked || !requestChangesControl.value?.trim()"
      (click)="handleSubmitRequestChanges()"
    >
      <qai-icon [kind]="'arrow-up'" [color]="'white'" [size]="'16px'" />
    </button>
  </div>
</div>
